/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-03-06T13:14:32.248Z by lizhutang (lizhutang@spolo.org)

'use strict'

import compManager from './compManager'
import constVars from '../bs4/consts'

const LayerdatalistID = 'layerdatalist'
function updateDatalist (wwInst) {
  let $datalist = $(`#${LayerdatalistID}`)
  if ($datalist.length === 0) {
    $('body').append($(`<datalist id=${LayerdatalistID}></datalist>`))
    $datalist = $(`#${LayerdatalistID}`)
  }
  let layers = wwInst.getLayers()
  let internalHTML = ''
  for (let key in layers) {
    if (key !== constVars.mainLayerName) {
      internalHTML += `<option>@{${key}}</option>`
    }
  }
  $datalist.html(internalHTML)
}

function setupStore (editor) {
  editor.StorageManager.add('wwstorage', {
    load: function (keys, clb, clbErr) {
      let inst = editor.wwinst
      inst.load(function (err) {
        const result = {}
        if (!err) {
          let curName = inst.currentLayer()
          let layer = inst.getLayers(curName)
          keys.forEach(key => {
            const value = layer[key]
            if (value) {
              result[key] = value
            }
          })
          updateDatalist(inst)
        }
        clb(result)
      })
    },
    store: function (data, clb, clbErr) {
      let inst = editor.wwinst
      let curName = inst.currentLayer()
      let layer = inst.getLayers(curName)
      console.log('store data=', data)
      if (!layer) {
        inst.updateLayer(curName, data)
        updateDatalist(inst)
      } else {
        for (let key in data) {
          layer[key] = data[key]
        }
      }
      inst.store(clb)
    }
  })
}

function loadDep (wwInst, htmlContent) {
  let $ctx = $(htmlContent)
  let Tasks = []
  $ctx.find('[data-comp-url]').each(function () {
    // 对每个data-wwclass做处理。
    let editorName = $(this).attr('data-comp-name') || ''
    let editorURL = $(this).attr('data-comp-url')
    let task = compManager.get(wwInst, editorName, editorURL)
    Tasks.push(task)
  })
  return Promise.all(Tasks)
}

export default {
  setup: setupStore,
  loadDep: loadDep
}
